/* import __COLOCATED_TEMPLATE__ from './trial-started-modal.hbs'; */
/* RESPONSIBLE TEAM: team-automation-foundations */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import type AppService from 'embercom/services/app-service';
import type { AgentTrialType } from 'embercom/lib/operator/fin/types';

interface Args {
  agentTypes: AgentTrialType[];
  onClose: () => void;
}

interface Signature {
  Args: Args;
}

export default class TrialStartedModal extends Component<Signature> {
  @service declare intl: IntlService;
  @service declare appService: AppService;

  get hasSupport(): boolean {
    return this.args.agentTypes.includes('support');
  }

  get hasSales(): boolean {
    return this.args.agentTypes.includes('sales');
  }

  get hasBoth(): boolean {
    return this.hasSupport && this.hasSales;
  }

  get benefitText(): string {
    if (this.hasBoth) {
      return this.intl.t(
        'operator.workflows.visual-builder.pass-to-fin.settings.trial-started.benefit-both',
      );
    } else if (this.hasSales) {
      return this.intl.t(
        'operator.workflows.visual-builder.pass-to-fin.settings.trial-started.benefit-sales',
      );
    }
    return this.intl.t(
      'operator.workflows.visual-builder.pass-to-fin.settings.trial-started.benefit-support',
    );
  }

  get pricingText(): string {
    if (this.hasBoth) {
      return this.intl.t(
        'operator.workflows.visual-builder.pass-to-fin.settings.trial-started.pricing-both',
      );
    } else if (this.hasSales) {
      return this.intl.t(
        'operator.workflows.visual-builder.pass-to-fin.settings.trial-dialog.pricing-sales',
      );
    }
    return this.intl.t(
      'operator.workflows.visual-builder.pass-to-fin.settings.trial-dialog.pricing-support',
    );
  }

  get closeButtonLabel(): string {
    if (this.hasSales && !this.hasSupport) {
      return this.intl.t(
        'operator.workflows.visual-builder.pass-to-fin.settings.trial-started.continue',
      );
    }
    return this.intl.t('operator.workflows.visual-builder.pass-to-fin.settings.trial-dialog.close');
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::GraphEditor::NodeItems::Steps::Fin::TrialStartedModal': typeof TrialStartedModal;
  }
}
